import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import { dataResources } from 'utils/constants';
import styles from './codiespectador.module.scss';

const { basePath } = dataResources;

export default function CodiEspectador(props) {
    const { codi, mida, className, estil } = props;

    let codiEdat = codi?.replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');

    //ELIMINAR AMB ELS NÒUS CÒDIS ÈTICS
    if (codiEdat === 'IN') {
        codiEdat = 'TP';
    }

    const styleIcona = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let src = basePath + '/_resources/icones/codisEspectador/codisEspectador' + codiEdat + '.svg?v=JIT_ENV_RESOURCES_VERSION';

    const imageLoader = ({ src }) => {
        return `${src}`;
    };

    return (
        //ELIMINAR I DESCOMENTAR AMB ELS NÒUS CÒDIS ÈTICS
        codiEdat &&
        codiEdat !== 'TP' && (
            //codiEdat && (

            <span className={styleIcona} data-testid={`codi-espectador-${codiEdat}`}>
                <Image
                    loader={imageLoader}
                    //ELIMINAR I DESCOMENTAR AMB ELS NÒUS CÒDIS ÈTICS
                    width={codiEdat === 'AD' ? mida * 1.6 : mida}
                    //width={codiEdat === 'AD' ? mida * 1.6 : codiEdat === 'IN' ? mida * 3.12 : mida}
                    height={mida}
                    alt=''
                    src={src}
                    unoptimized={true}
                    aria-hidden={true}
                />
            </span>
        )
    );
}

CodiEspectador.defaultProps = {
    codi: '',
    mida: '20',
    className: ''
};
